import Layout from '../../components/feature/Layout';
import SEO from '../../components/feature/SEO';

export default function HSEConInteligenciaPage() {
  return (
    <Layout>     
          <SEO
  title="HSE con Inteligencia | SafeLine Solutions"
  description="Aprende a utilizar Inteligencia Artificial aplicada a HSE para detectar patrones, analizar incidentes y fortalecer la prevención operacional."
  keywords="HSE con Inteligencia, IA aplicada a HSE, prevención operacional, inteligencia artificial, seguridad operacional"
  canonical="/hse-con-inteligencia"
  image="/og-hse-inteligencia.jpg"
/>

      <div className="pt-20 bg-white">

        {/* HERO */}
        <section className="bg-gradient-to-br from-slate-900 to-teal-900 text-white py-24">

          <div className="max-w-7xl mx-auto px-6">

            <div className="grid lg:grid-cols-2 gap-16 items-center">

              {/* LEFT */}
              <div>

                <span className="bg-teal-500/20 text-teal-300 px-4 py-2 rounded-full text-sm font-semibold">
                  Innovación HSE + IA
                </span>

                <h1 className="text-5xl lg:text-7xl font-extrabold mt-6 leading-tight">
                  HSE con <span className="text-teal-400">Inteligencia</span>
                </h1>

                {/* BOOK LABEL */}
                <div className="mt-5 inline-flex items-center border border-white/10 bg-white/5 backdrop-blur-sm px-5 py-2 rounded-full">

                  <span className="text-white/80 text-sm font-medium tracking-wide">
                    Libro 1 · Patrones y Prevención
                  </span>

                </div>

                <p className="text-xl text-slate-300 mt-8 leading-relaxed">
  Aprende a usar Inteligencia Artificial para detectar patrones de incidentes,
  analizar causas sistémicas y prevenir accidentes antes del daño.
</p>

<p className="text-white/80 text-base mt-6 font-medium">
  Diseñado para profesionales HSE, operaciones, minería y energía.
</p>

{/* PRICE */}
<div className="mt-8">

  <p className="text-2xl font-bold text-white">

    <span className="line-through text-white/50 mr-3">
      $27 USD
    </span>

    <span className="text-teal-300">
      $15 USD
    </span>

  </p>

  <p className="text-sm text-white/70 mt-1">
    Precio de lanzamiento
  </p>

</div>

{/* CTA BUTTONS */}
<div className="flex flex-wrap gap-4 mt-10">

                  {/* BUY */}
                  <a
                    href="https://pay.hotmart.com/O106146732J"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-teal-500 hover:bg-teal-600 transition-all px-8 py-4 rounded-xl font-bold text-lg shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-300"
                  >
                    Comprar ahora
                  </a>

                  {/* METHOD */}
                  <a
                    href="#metodo"
                    className="border border-white/30 hover:bg-white/10 transition-all px-8 py-4 rounded-xl font-semibold text-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                  >
                    Ver metodología
                  </a>

                  {/* TECHNICAL EXTRACT */}
                  <a
                    href="https://safelinesolutions.net/downloads/extracto-tecnico-hse-con-inteligencia.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white/10 hover:bg-white/20 border border-white/10 transition-all px-8 py-4 rounded-xl font-semibold text-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                  >
                    Descargar extracto técnico
                  </a>

                </div>

              </div>

              {/* RIGHT IMAGE */}
              <div className="flex justify-center">

                
                <img
                  src="/images/hse-book-mockup.png"
                  alt="Libro HSE con Inteligencia"
                  className="rounded-3xl shadow-2xl max-w-xl w-full object-contain"
                />


              </div>

            </div>

          </div>

        </section>

        {/* PROBLEMA */}
        <section className="py-24 bg-slate-50">

          <div className="max-w-7xl mx-auto px-6">

            <div className="text-center max-w-4xl mx-auto">

              <h2 className="text-4xl lg:text-5xl font-extrabold text-slate-900">
                El problema no es la falta de <span className="text-teal-600">datos</span>
              </h2>

              <p className="text-slate-600 text-xl mt-8 leading-relaxed">
                Las organizaciones generan cientos de reportes, incidentes y acciones correctivas.
                Pero los mismos eventos siguen repitiéndose porque el sistema no está leyendo
                los patrones detrás de ellos.
              </p>

            </div>

            <div className="grid md:grid-cols-3 gap-8 mt-20">

              {/* CARD 1 */}
              <div className="bg-white rounded-3xl p-10 shadow-sm border border-slate-100">

                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  Converger
                </h3>

                <p className="text-slate-600 leading-relaxed">
                  Detecta conexiones entre incidentes aparentemente aislados
                  utilizando IA y análisis de patrones.
                </p>

              </div>

              {/* CARD 2 */}
              <div className="bg-white rounded-3xl p-10 shadow-sm border border-slate-100">

                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  Comprender
                </h3>

                <p className="text-slate-600 leading-relaxed">
                  Identifica causas sistémicas más allá de la causa inmediata
                  para prevenir la repetición real.
                </p>

              </div>

              {/* CARD 3 */}
              <div className="bg-white rounded-3xl p-10 shadow-sm border border-slate-100">

                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  Actuar
                </h3>

                <p className="text-slate-600 leading-relaxed">
                  Diseña acciones preventivas medibles, verificables
                  y orientadas al cambio operacional.
                </p>

              </div>

            </div>

          </div>

        </section>

        {/* METODO */}
        <section
          id="metodo"
          className="py-24 bg-slate-900 text-white"
        >

          <div className="max-w-7xl mx-auto px-6">

            <div className="text-center max-w-4xl mx-auto">

              <h2 className="text-4xl lg:text-5xl font-extrabold">
                IA aplicada a <span className="text-teal-400">Seguridad Operacional</span>
              </h2>

              <p className="text-slate-300 text-xl mt-8 leading-relaxed">
                Este método integra herramientas como ChatGPT, Copilot, Gemini y Claude
                para acelerar el análisis de incidentes y fortalecer la toma de decisiones preventivas.
              </p>

            </div>

            <div className="mt-20 text-center">

              <p className="text-4xl lg:text-5xl font-extrabold leading-tight max-w-5xl mx-auto">
                “La IA analiza. <span className="text-teal-400">El profesional decide.</span> El terreno valida.”
              </p>

            </div>

            {/* FEATURE CARDS */}
            <div className="grid md:grid-cols-2 gap-6 mt-20">

              {/* CARD 1 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
                }}
              >

                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-terminal-box-line text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Prompts profesionales
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Prompts diseñados para investigaciones, análisis y gestión preventiva operacional.
                </p>

              </div>

              {/* CARD 2 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
                }}
              >

                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-building-line text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Casos reales
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Ejemplos prácticos y escenarios operacionales aplicados a entornos HSE reales.
                </p>

              </div>

              {/* CARD 3 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
                }}
              >

                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-focus-3-line text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Framework CCA
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Método estructurado para converger, comprender y actuar sobre incidentes y riesgos.
                </p>

              </div>

              {/* CARD 4 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
                }}
              >

                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-flashlight-line text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Aplicación inmediata
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Implementación rápida en procesos HSE y operaciones industriales.
                </p>

              </div>

              {/* CARD 5 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
                }}
              >

                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-radar-line text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Análisis sistémico
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Identificación de patrones recurrentes y causas operacionales profundas.
                </p>

              </div>

              {/* CARD 6 */}
              <div
                className="rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: '#18384C',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
                }}
              >

                <div className="w-12 h-12 bg-teal-500/15 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-ai-generate text-2xl text-teal-400"></i>
                </div>

                <h3 className="text-white font-semibold text-lg">
                  Compatible con IA
                </h3>

                <p className="text-white/80 text-sm mt-3 leading-relaxed">
                  Integración práctica con ChatGPT, Copilot y herramientas modernas de IA.
                </p>

              </div>

            </div>

          </div>

        </section>

        {/* CTA FINAL */}
        <section className="py-28 bg-teal-600 text-white text-center">

          <div className="max-w-5xl mx-auto px-6">

            <h2 className="text-5xl lg:text-6xl font-extrabold leading-tight">
              Detecta patrones antes de que se conviertan en accidentes
            </h2>

            <p className="text-xl mt-10 text-teal-50 leading-relaxed">
              Desarrollado desde experiencia real en gestión HSE y operaciones industriales en Latinoamérica.
            </p>

            <div className="mt-12">

              <a
                href="https://pay.hotmart.com/O106146732J"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-teal-700 hover:bg-slate-100 transition-all px-10 py-5 rounded-2xl font-bold text-xl shadow-xl inline-block focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-700"
              >
                Comprar ahora
              </a>

            </div>

          </div>

        </section>

      </div>

    </Layout>
  );
}